// react-native-spinkit has no web build. PrimaryButton renders <Loader/> as a
// component, so the shim must be a valid (null-rendering) React component.
const React = require("react");
function Loader() {
  return null;
}
module.exports = Loader;
module.exports.default = Loader;
